(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/keno-xpress/assets/react/game-container.js') >= 0) return;  svs.modules.push('/modules/keno-xpress/assets/react/game-container.js');
"use strict";


const {
  useEffect
} = React;
const {
  isWagerCompleted,
  getWager
} = svs.kenoXpress.react.utils.wager;
const GameContainer = () => {
  const Payfooter = svs.tur.ReactPayfooter.Payfooter;
  const {
    Betslip,
    Receipt,
    GameUnavailable
  } = svs.kenoXpress.react.components;
  const {
    ref,
    loading,
    gameState,
    showPayment,
    isAlreadyPayed,
    gameUnavailable,
    handleDemoGame,
    handlePayGame,
    onPlayAgain
  } = svs.kenoXpress.react.hooks.useKenoXpress();
  const [resizeGame] = svs.kenoXpress.react.hooks.useFullSizeScreenGameResize(ref);
  const isCompleted = isWagerCompleted();
  svs.kenoXpress.react.hooks.useLoader(ref, loading);
  useEffect(() => {
    resizeGame();
  }, [resizeGame, showPayment, loading]);
  if (gameUnavailable) {
    return React.createElement(GameUnavailable, null);
  }
  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: "keno-xpress-leia-flex"
  }, React.createElement("div", {
    className: "keno-xpress-leia"
  }, React.createElement("div", {
    ref: ref
  }))), React.createElement("div", {
    id: "kex-pay-footer"
  }, !loading && isCompleted ? React.createElement(Receipt, {
    wager: getWager()
  }) : null, showPayment && React.createElement(Betslip, {
    handleDemoGame: handleDemoGame,
    handlePayGame: handlePayGame,
    hasKungKeno: gameState.kungKeno,
    isAlreadyPayed: isAlreadyPayed,
    isVisible: Boolean(gameState.kenoNumbers.length),
    selectedPrice: gameState.stake
  }), !loading && isCompleted && React.createElement(Payfooter, {
    buttons: [{
      primary: true,
      text: 'Spela igen',
      onClick: onPlayAgain
    }],
    isFixed: true,
    reminderTrackingLabel: "KenoXpress"
  })));
};
svs.kenoXpress.react.GameContainer = GameContainer;

 })(window);